import PropTypes from 'prop-types';
import React from 'react';
import { cymbioColors } from '../../../utils/colors';

const strokeColor = cymbioColors.analytics.textSecondary;

export function CountryIcon({ color = strokeColor }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_0_5989)">
        <path
          d="M5 5.00009C5.93464 4.08395 7.19124 3.5708 8.5 3.5708C9.80876 3.5708 11.0654 4.08395 12 5.00009C12.9346 5.91622 14.1912 6.42937 15.5 6.42937C16.8088 6.42937 18.0654 5.91622 19 5.00009V14.0001C18.0654 14.9162 16.8088 15.4294 15.5 15.4294C14.1912 15.4294 12.9346 14.9162 12 14.0001C11.0654 13.084 9.80876 12.5708 8.5 12.5708C7.19124 12.5708 5.93464 13.084 5 14.0001V5.00009Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M5 21V14" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_0_5989">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

CountryIcon.propTypes = {
  color: PropTypes.string,
};
